import type { StatusColor } from '@uiKit/components/StatusBadge.vue'
import { BANK_ACCOUNT_STATUS, type BankAccountStatus } from '../types/bankAccountsDirectoryTypes'

const STATUS_COLOR: Record<string, StatusColor> = {
  [BANK_ACCOUNT_STATUS.PENDING_VERIFICATION]: 'warning',
  [BANK_ACCOUNT_STATUS.VERIFICATION_IN_PROGRESS]: 'info',
  [BANK_ACCOUNT_STATUS.VERIFIED]: 'success',
  [BANK_ACCOUNT_STATUS.VERIFICATION_FAILED]: 'danger',
  [BANK_ACCOUNT_STATUS.REJECTED]: 'danger',
}

const STATUS_LABEL: Record<string, string> = {
  [BANK_ACCOUNT_STATUS.PENDING_VERIFICATION]: 'Pending verification',
  [BANK_ACCOUNT_STATUS.VERIFICATION_IN_PROGRESS]: 'In progress',
  [BANK_ACCOUNT_STATUS.VERIFIED]: 'Verified',
  [BANK_ACCOUNT_STATUS.VERIFICATION_FAILED]: 'Failed',
  [BANK_ACCOUNT_STATUS.REJECTED]: 'Rejected',
}

export function getBankAccountStatusColor(status: BankAccountStatus): StatusColor {
  return STATUS_COLOR[status] ?? 'neutral'
}

export function getBankAccountStatusLabel(status: BankAccountStatus): string {
  return STATUS_LABEL[status] ?? status
}

export const BANK_ACCOUNT_STATUS_OPTIONS = [
  { label: 'Pending verification', value: BANK_ACCOUNT_STATUS.PENDING_VERIFICATION },
  { label: 'In progress', value: BANK_ACCOUNT_STATUS.VERIFICATION_IN_PROGRESS },
  { label: 'Verified', value: BANK_ACCOUNT_STATUS.VERIFIED },
  { label: 'Failed', value: BANK_ACCOUNT_STATUS.VERIFICATION_FAILED },
  { label: 'Rejected', value: BANK_ACCOUNT_STATUS.REJECTED },
] as const
